import { Text } from "@/components/typography/Text";

interface StatsProps {
  nodesCount: number;
  tenantsCount: number;
  usersCount: number;
}

const countFormatter = new Intl.NumberFormat("en-US");

export default function Stats({ nodesCount, tenantsCount, usersCount }: StatsProps) {
  return (
    <div className="relative">
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-4xl">
          <dl className="rounded-lg sm:grid sm:grid-cols-3">
            <div className="flex flex-col border-b border-gray-100 p-6 text-center sm:border-0 sm:border-r">
              <Text as="dt" size="meta" className="order-2 font-bold">
                عدد الشجرات
              </Text>
              <dd className="order-1 text-4xl font-extrabold text-green-600">
                <span>{countFormatter.format(tenantsCount)}</span>
                <span className="mx-1 text-sm text-gray-400">شجرةً</span>
              </dd>
            </div>
            <div className="flex flex-col border-t border-b border-gray-100 p-6 text-center sm:border-0 sm:border-r sm:border-l">
              <Text as="dt" size="meta" className="order-2 font-bold">
                عدد الأفراد
              </Text>
              <dd className="order-1 text-4xl font-extrabold text-green-600">
                <span>{countFormatter.format(nodesCount)}</span>
                <span className="mx-1 text-sm text-gray-400">فردًا</span>
              </dd>
            </div>
            <div className="flex flex-col border-t border-gray-100 p-6 text-center sm:border-0 sm:border-l">
              <Text as="dt" size="meta" className="order-2 font-bold">
                عدد الحسابات
              </Text>
              <dd className="order-1 text-4xl font-extrabold text-green-600">
                <span>{countFormatter.format(usersCount)}</span>
                <span className="mx-1 text-sm text-gray-400">حسابًا</span>
              </dd>
            </div>
          </dl>
        </div>
      </div>
    </div>
  );
}
